<template>
  <div class="invitation-form">
    <el-form class="form" ref="form" :model="form" label-width="110px">
      <el-form-item label="是否付费">
        <el-switch
          v-model="form.is_need_pay"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item label="轮播图">
        <div class="swiper-img">
          <img class="cursor-pointer" :src="item + '?imageView2/2/w/300|imageslim'" v-for="(item, index) in form.images" :key="index" @click="selectThumb(form.images)">
          <el-button size="small" v-if="!form.images.length" @click="selectThumb(form.images)">选择图片</el-button>
        </div>
      </el-form-item>
      <el-form-item label="选填">
        <div class="select-input">
          <h4>邮箱</h4>
          <el-radio-group v-model="form.options.email.show">
            <el-radio :label="0">不显示</el-radio>
            <el-radio :label="1">选填</el-radio>
            <el-radio :label="2">必填</el-radio>
          </el-radio-group>
        </div>
        <div class="select-input">
          <h4>地址</h4>
          <el-radio-group v-model="form.options.address.show">
            <el-radio :label="0">不显示</el-radio>
            <el-radio :label="1">选填</el-radio>
            <el-radio :label="2">必填</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item label="场次信息" v-if="!isedit">
        <div class="session" v-for="(item,index) in form.sessions" :key="index">
          <span class="number">{{index+1}}.</span>
          <!-- <span class="name">名称：{{item.name}}</span> -->
          <span class="day">时间：{{item.day}}&nbsp;{{item.start_time}} - {{item.day}}&nbsp;{{item.end_time}}</span>
          <el-button size="small" type="text" @click="editSession(index)">编辑</el-button>
          <el-button size="small" type="text" @click="deleteSession(index)">删除</el-button>
        </div>
        <el-button size="small" @click="newSession">添加场次</el-button>
      </el-form-item>
      <el-form-item label="界面底部描述">
        <VueUEditor
          ueditorPath="/static/q_ueditor/"
          @ready="editorReady2"
          style="width:500px">
        </VueUEditor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">立即保存</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="添加场次"
      :visible.sync="dialogVisible"
      width="900px"
      append-to-body>
      <el-form label-width="100px" class="form2">
        <!-- <el-form-item label="名称" class="form2-item">
          <el-input v-model="form2.name" style="width:400px"></el-input>
        </el-form-item> -->
        <el-form-item label="日期" class="form2-item">
          <el-date-picker
            v-model="form2.day"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开始时间" class="form2-item">
          <el-input v-model="form2.start_time" style="width:400px" placeholder="格式：10:30"></el-input>
        </el-form-item>
        <el-form-item label="结束时间" class="form2-item">
          <el-input v-model="form2.end_time" style="width:400px" placeholder="格式：10:30"></el-input>
        </el-form-item>
        <el-form-item label="最小人数" class="form2-item">
          <el-input-number v-model="form2.min_people" :min="1" label="最小人数"></el-input-number>
        </el-form-item>
        <el-form-item label="最大人数" class="form2-item">
          <el-input-number v-model="form2.max_people" :min="1" label="最大人数"></el-input-number>
        </el-form-item>
        <el-form-item label="库存" class="form2-item">
          <el-input v-model.number="form2.stock" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="价格" class="form2-item" v-if="form.is_need_pay">
          <el-input v-model.number="form2.price" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="截止预约时间" class="form2-item">
          <el-date-picker
            v-model="form2.bookable_before_at"
            type="datetime"
            placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSession">确 定</el-button>
      </span>
    </el-dialog>
    <upload-img ref="upload"></upload-img>
  </div>
</template>
<script>
import VueUEditor from 'vue-ueditor'
import UploadImg from '@/components/UploadImg'
export default {
  name: 'invitationForm',
  components: {
    UploadImg,
    VueUEditor
  },
  props: {
    form: {
      type: Object
    },
    isedit: {
      type: Boolean
    }
  },
  data () {
    return {
      form2: {
        name: '展览', // 场次名称
        day: '', // 天日期
        start_time: '', // 开始时分
        end_time: '', // 结束时分
        min_people: 1, // 最小预约人数
        max_people: 100, // 最大预约人数
        stock: 0, // 库存
        price: 0, // 100元/人, 单位分
        bookable_before_at: ''
      },
      dialogVisible: false,
      editsession: false,
      current: 0
    }
  },
  methods: {
    editorReady2 (editor) {
      editor.setContent(this.form.description)
      editor.addListener('contentChange', _ => {
        this.form.description = editor.getContent()
      })
    },
    selectThumb () {
      this.$refs.upload.show(this.form.images, 'other', 30).then(res => {
        this.form.images = res
      }).catch(_ => {})
    },
    newSession () {
      this.editsession = false
      this.dialogVisible = true
    },
    editSession (index) {
      this.editsession = true
      this.current = index
      let form = this.form.sessions[index]
      this.form2 = JSON.parse(JSON.stringify(form))
      this.dialogVisible = true
    },
    deleteSession (index) {
      this.form.sessions.splice(index, 1)
    },
    addSession () {
      if (this.editsession) {
        this.form.sessions[this.current] = JSON.parse(JSON.stringify(this.form2))
      } else {
        this.form.sessions.push(JSON.parse(JSON.stringify(this.form2)))
      }
      this.dialogVisible = false
      this.form2 = {
        name: '展览', // 场次名称
        day: '', // 天日期
        start_time: '', // 开始时分
        end_time: '', // 结束时分
        min_people: 1, // 最小预约人数
        max_people: 100, // 最大预约人数
        stock: 0, // 库存
        price: 0 // 100元/人, 单位分
      }
    },
    submit () {
      this.$emit('submit')
    }
  }
}
</script>
<style lang="less" scoped>
.invitation-form {
  .form {
    width: 900px;
  }
  .swiper-img {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img {
      height: 60px;
      width: auto;
      margin-right: 15px;
      margin-bottom: 15px;
    }
  }
  .session {
    .day {
      padding: 0 15px;
    }
  }
  .select-input {
    display: flex;
    align-items: center;
    h4 {
      margin-right: 15px;
    }
  }
  .form2 {
    /deep/ .el-form-item__content {
      padding: 5px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/booking/components/invitationForm.vue